import api from './index'

export async function getImpersonationToken(
  token: string | null,
  impersonateUserId: string | null,
) {
  const impersonationPromise = await api
    .post(
      `/users/impersonate/${impersonateUserId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .catch((err) => {
      console.error(err)
    })

  if (impersonationPromise && impersonationPromise.status == 200) {
    console.log(impersonationPromise.data)
    return {
      token: impersonationPromise.data.token,
      office_location: impersonationPromise.data.user.office_location,
    }
  }

  return {}
}
